import Dashboard from '@/views/Dashboard/index.vue'

export const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
]
